module.exports = __webpack_public_path__ + "img/property.2da836d6.jpg";